import React, { useState } from 'react';

// Sample project data (you would likely fetch this from an API in a real application)
const projectsData = [
  {
    id: 1,
    title: 'Seoul - Asiana Airlines Hangar',
    location: 'Incheon Havalimanı',
    category: 'airport',
    imageUrl: '/collect/545-asiana-airlines-01.jpg',
    link: '/projects/seoul-asiana-airlines-hangar', // Link adjusted
  },
  {
    id: 2,
    title: 'İstanbul - THY Hangarları',
    location: 'Sabiha Gökçen Havalimanı',
    category: 'airport',
    imageUrl: '/collect/545-sabiha-gokcen-012.jpg',
    link: '/projects/istanbul-thy-hangarlari', // Link adjusted
  },
  {
    id: 3,
    title: 'İstanbul - İş Jeti Hangarları',
    location: 'Sabiha Gökçen Havalimanı',
    category: 'airport',
    imageUrl: '/collect/540-sabiha-gokcen-is-jeti-business-jet-hangar-4955.jpg',
    link: '/projects/istanbul-is-jeti-hangarlari', // Link adjusted
  },
  {
    id: 4,
    title: 'Mönchengladbach - Yeni Hangar',
    location: 'Mönchengladbach Havaalanı',
    category: 'airport',
    imageUrl: '/collect/545-schmitter-tore-monchengladbach-hangar-door-kapi-6508.jpg',
    link: '/projects/monchengladbach-yeni-hangar', // Link adjusted
  },
  {
    id: 5,
    title: 'Chambley-Bussières - Planet Air Hangarları',
    location: 'Chambley-Bussières Hava Üssü',
    category: 'airport',
    imageUrl: '/collect/545-chambley-4403.jpg',
    link: '/projects/chambley-bussieres-planet-air-hangarlari', // Link adjusted
  },
  {
    id: 6,
    title: 'Tersane',
    location: 'Türkmen Marine - Bodrum',
    category: 'industrial',
    imageUrl: '/collect/545-panolux-turkmen-marine-5176.jpg',
    link: '/projects/tersane', // Link adjusted
  },
  {
    id: 7,
    title: 'Endüstriyel tesis',
    location: 'Antrepo kapıları',
    category: 'industrial', // Category corrected
    imageUrl: '/collect/545-panolux-764.jpg',
    link: '/projects/endustriyel-tesis', // Link adjusted
  },
  {
    id: 8,
    title: 'Konut',
    location: 'Işık geçiren tavanlar',
    category: 'residential',
    imageUrl: '/collect/545-panolux-ceiling-01.jpg',
    link: '/projects/konut', // Link adjusted
  },
  {
    id: 9,
    title: 'Ofis',
    location: 'Işık geçiren seperasyonlar',
    category: 'office',
    imageUrl: '/collect/545-panolux-6800.jpg',
    link: '/projects/ofis', // Link adjusted
  },
];

function YayindanSection() {
  const [filter, setFilter] = useState('all');
  const [isAnimating, setIsAnimating] = useState(false); // Animasyon durumunu takip etmek için state

  const categories = [
    { name: 'all', label: 'Tüm projeler' },
    { name: 'airport', label: 'Hava Limanı' },
    { name: 'industrial', label: 'Endüstriyel' },
    { name: 'residential', label: 'Konut' },
    { name: 'office', label: 'Ofis' },
  ];

  const handleFilterChange = (newFilter) => {
    if (newFilter === filter) return; // Aynı kategoriye tıklanırsa animasyon tetikleme

    setIsAnimating(true); // Animasyonu başlat
    setTimeout(() => {
      setFilter(newFilter);
      setIsAnimating(false); // Animasyonu bitir
    }, 300); // Bu süre CSS geçiş süresiyle aynı olmalı (300ms)
  };

  const filteredProjects = projectsData.filter(project => {
    if (filter === 'all') {
      return true;
    }
    return project.category === filter;
  });

  // Function to create a URL friendly slug from the title
  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric characters except spaces and hyphens
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-'); // Replace multiple hyphens with a single hyphen
  };

  return (
    <div className="font-inter antialiased">
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Title */}
          <h2 className="text- xl sm:text-2xl border-black border-b-[1px] w-1/2 mx-auto pb-4 font-light text-center text-gray-900 mb-12">
  Uygulama örnekleri
</h2>

          {/* Filter Buttons */}
          <div className="flex justify-center mb-10   flex-wrap">
            {categories.map((cat, index) => (
              <React.Fragment key={cat.name}>
                {index > 0 && (
                  <span className="text-gray-400 self-center text-sm hidden sm:block">/</span>
                )}
                <button
                  onClick={() => handleFilterChange(cat.name)} // Yeni handle fonksiyonu
                  className={`
                    py-2 px-4 sm:px-6 rounded-full text-base sm:text-lg font-light transition-all duration-300 ease-in-out
                    ${filter === cat.name
                      ? 'text-emerald-600 ' // Active state
                      : '' // Inactive state
                    }
                  `}
                >
                  {cat.label}
                </button>
              </React.Fragment>
            ))}
          </div>

          {/* Project Grid */}
          <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 
            ${isAnimating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'} 
            transition-all duration-300 ease-in-out`}>
            {filteredProjects.map(project => (
              <a
                key={project.id}
                href={project.link || `/projects/${createSlug(project.title)}`}
                className="
                  block bg-white overflow-hidden
                  transform hover:scale-105 hover:shadow-2xl transition-all duration-300 ease-in-out
                  group
                "
              >
                {/* Project Image */}
                <div className="relative w-full h-56 overflow-hidden">
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                    // Fallback for image loading errors
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = `https://placehold.co/600x400/CCCCCC/333333?text=Image+Error`;
                    }}
                  />
                </div>
                <div className="absolute inset-0 bg-emerald-600/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  {/* Overlay for hover effect */}
                </div>

                {/* Project Info */}
                <div className="p-5">
                  <h3 className="text-sm font-semibold text-gray-900 mb-2 leading-tight text-center">
                    {project.title}
                  </h3>
                  <p className="text-sm text-gray-600 text-center">
                    {project.location}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default YayindanSection;